import { useState } from "react";
import { Modal, Button, Form, FormGroup, FormLabel, FormControl, FormCheck, Spinner, InputGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import APIAdmin from "../Authentification/apiAdmin";
import { PERMISSIONS_CONFIG } from "./PermissionsConfig";
import {
    faEye,
    faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// const PERMISSIONS_LIST = [
//     { key: "produits", label: "Gestion des produits" },
//     { key: "commandes", label: "Gestion des commandes" },
//     { key: "clients", label: "Gestion des clients" },
//     { key: "statistiques", label: "Statistiques & rapports" },
//     { key: "promotions", label: "Promotions & publicités" },
//     { key: "parametres", label: "Paramètres" },
// ];

const AjouterSousCompte = ({ show, onClose, onCreated }) => {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        password: "",
        password_confirmation: "",
    });
    const [permissions, setPermissions] = useState([]);
    const [errors, setErrors] = useState({});
    const [isLoading, setLoading] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    const togglePermission = (key) => {
        setPermissions((prev) =>
            prev.includes(key) ? prev.filter((p) => p !== key) : [...prev, key]
        );
        setErrors((prev) => ({ ...prev, permissions: "" }));
    };

    const resetForm = () => {
        setForm({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            password: "",
            password_confirmation: "",
        });
        setPermissions([]);
        setErrors({});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (permissions.length === 0) {
            setErrors((prev) => ({ ...prev, permissions: "Sélectionnez au moins un accès." }));
            return;
        }

        try {
            setLoading(true);
            const token = localStorage.getItem("adminToken");

            const response = await APIAdmin.post(
                "/admin/sous-comptes",
                { ...form, permissions },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            toast.success(response.data.message || "Sous-compte créé avec succès !");
            resetForm();
            onCreated?.(response.data.admin);
            onClose();
        } catch (error) {
            if (error.response?.status === 422) {
                setErrors(error.response.data.errors || {});
            } else if (error.response?.status === 403) {
                toast.error("Vous n'avez pas l'autorisation de créer un sous-compte.");
            } else {
                toast.error("Une erreur est survenue. Veuillez réessayer.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title className="petit_titre">Ajouter un sous-compte</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className="row">
                        <FormGroup className="col-md-6 mb-3">
                            <FormLabel className="texte_brut">Prénom</FormLabel>
                            <FormControl
                                name="firstName"
                                value={form.firstName}
                                onChange={handleChange}
                                isInvalid={!!errors.firstName}
                                required
                            />
                            <FormControl.Feedback type="invalid">{errors.firstName}</FormControl.Feedback>
                        </FormGroup>
                        <FormGroup className="col-md-6 mb-3">
                            <FormLabel className="texte_brut">Nom</FormLabel>
                            <FormControl
                                name="lastName"
                                value={form.lastName}
                                onChange={handleChange}
                                isInvalid={!!errors.lastName}
                                required
                            />
                            <FormControl.Feedback type="invalid">{errors.lastName}</FormControl.Feedback>
                        </FormGroup>
                    </div>
                    <div className="row">
                        <FormGroup className="col-md-6 mb-3">
                            <FormLabel className="texte_brut">Email</FormLabel>
                            <FormControl
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                                required
                            />
                            <FormControl.Feedback type="invalid">{errors.email}</FormControl.Feedback>
                        </FormGroup>
                        <FormGroup className="col-md-6 mb-3">
                            <FormLabel className="texte_brut">Téléphone</FormLabel>
                            <FormControl
                                name="phone"
                                placeholder="01 ** ** ** **"
                                value={form.phone}
                                onChange={handleChange}
                                isInvalid={!!errors.phone}
                                required
                            />
                            <FormControl.Feedback type="invalid">{errors.phone}</FormControl.Feedback>
                        </FormGroup>
                    </div>
                    <div className="row">
                        <FormGroup className="col-md-6 mb-3">
                            <FormLabel className="texte_brut">Mot de passe</FormLabel>
                            <InputGroup>
                                <FormControl
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    value={form.password}
                                    onChange={handleChange}
                                    isInvalid={!!errors.password}
                                    required
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowPassword((prev) => !prev)}
                                    style={{ border: "1px solid #ced4da" }}
                                >
                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                </Button>
                            </InputGroup>
                            <FormControl.Feedback type="invalid">{errors.password}</FormControl.Feedback>
                        </FormGroup>
                        <FormGroup className="col-md-6 mb-3">
                            <FormLabel className="texte_brut">Confirmer le mot de passe</FormLabel>
                            <InputGroup>
                                <FormControl
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="password_confirmation"
                                    value={form.password_confirmation}
                                    onChange={handleChange}
                                    required
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                                    style={{ border: "1px solid #ced4da" }}
                                >
                                    <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                                </Button>
                            </InputGroup>
                        </FormGroup>
                    </div>

                    <FormLabel className="texte_brut d-block mt-2">Accès autorisés</FormLabel>
                    <div className="row">
                        {PERMISSIONS_CONFIG.map((perm) => (
                            <div className="col-md-6" key={perm.key}>
                                <FormCheck
                                    type="checkbox"
                                    id={`perm-${perm.key}`}
                                    label={perm.label}
                                    checked={permissions.includes(perm.key)}
                                    onChange={() => togglePermission(perm.key)}
                                />
                            </div>
                        ))}
                    </div>
                    {errors.permissions && (
                        <div className="text-danger petit_titre mt-1">{errors.permissions}</div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>
                        Annuler
                    </Button>
                    <Button type="submit" className="bg-primary border-0" disabled={isLoading}>
                        {isLoading ? <Spinner size="sm" animation="border" /> : "Créer le sous-compte"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default AjouterSousCompte;